import { useMutation } from "@tanstack/react-query";
import { instance } from "../../axios.config";
import { useUserStore } from "../../store/useUserStore";

export const useAuthActionType = () => {
  return useMutation({
    mutationFn: async (body) => {
      const { data } = await instance.post("get-mobile", body);
      return data;
    },
  });
};

export const useLogin = () => {
  const setUser = useUserStore((state) => state.setUser);
  return useMutation({
    mutationFn: async (body) => {
      const { data } = await instance.post("login", body);
      return data;
    },
    onSuccess: (data) => {
      const user = data.data;
      setUser({ ...user.user_info, auth: true });
      localStorage.setItem("token", user.token);
    },
  });
};

export const useSendCode = () => {
  return useMutation({
    mutationFn: async (body) => {
      const { data } = await instance.post("send-register-code", body);
      return data;
    },
  });
};

export const useRegister = () => {
  const setUser = useUserStore((state) => state.setUser);

  return useMutation({
    mutationFn: async (body) => {
      const { data } = await instance.post("register", body);
      return data;
    },
    onSuccess: (data) => {
      const user = data.data;
      setUser({ ...user.user_info, auth: true });
      localStorage.setItem("token", user.token);
    },
  });
};
